import styled from "styled-components";
import { FormSectionProps } from "../../types/common";

export const FormSection = ({
  title,
  children,
  className,
  props,
}: FormSectionProps) => {
  return (
    <Wrapper className="whiteBg radius10">
      <TitleWrapper className="flexNullCenter gap5">
        <div className="capitalize bold">{title}</div>
      </TitleWrapper>
      {/* FIELDS */}
      <ChildWrapper className={`p20 ${className}`} {...props}>
        {children}
      </ChildWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  @media (max-width: 960px) {
  }
`;

export const ChildWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }

  .fullWidth {
    grid-column: span 2;
    @media (max-width: 760px) {
      grid-column: 1;
    }
  }

  & > *:only-child {
    grid-column: span 2;
  }

  & > *:nth-last-child(1):nth-child(odd) {
    grid-column: span 2;
    @media (max-width: 760px) {
      grid-column: 1;
    }
  }
`;
const TitleWrapper = styled.div`
  padding: 15px;
  border-bottom: 1px solid #eee;
`;
